import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../util/AppContext';
import PropType from 'prop-types';
import FilterDropDown from './FilterDropDown';
import { getConfigValue } from '../../util/getConfigValue';
import Button from 'react-bootstrap/Button';

ReportGeographyDropDown.propTypes = {
    isMenuVisible: PropType.bool,
    setIsMenuVisible: PropType.func,
    isEnabled: PropType.bool,
    menuContentRef: PropType.object,
    menuRef: PropType.object,
    setFilterState: PropType.func,
    filterState: PropType.object
}

function ReportGeographyDropDown(props) {
    const {
        isMenuVisible,
        setIsMenuVisible,
        isEnabled,
        menuContentRef,
        menuRef,
        setFilterState,
        filterState
    } = props;

    const [appState] = useContext(AppContext);

    const defaultLabel = getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.SelectGeography?.Label, appState)?.Value || "Select Geography";
    const [selectedLabel, setSelectedLabel] = useState(defaultLabel);
    const [salesAreas, setSalesAreas] = useState(null);
    const [salesRegions, setSalesRegions] = useState(null);
    const [salesDistricts, setSalesDistricts] = useState(null);
    const [territories, setTerritories] = useState(null);
    const [selectedGeographyType, setSelectedGeographyType] = useState(null);
    const [selectedGeography, setSelectedGeography] = useState(null);
    const [previousSelections, setPreviousSelections] = useState({});
    const [filterAction, setfilterAction] = useState(FilterDropDown.SetAction(FilterDropDown.ActionTypes.NoAction, null));
    const [filteredOptions, setFilteredOptions] = useState([]);
    const geographyTypesAreaEnabled = getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.GeographyTypes?.Area?.Enabled, appState)
    const geographyTypesRegionEnabled = getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.GeographyTypes?.Region?.Enabled, appState)
    const geographyTypesDistrictEnabled = getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.GeographyTypes?.District?.Enabled, appState)
    const geographyTypesTerritoryEnabled = getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.GeographyTypes?.Territory?.Enabled, appState)

    const constants = {
        Area: { label: getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.GeographyTypes?.Area.Label, appState)?.Value || 'Area', value: "Area" },
        Region: { label: getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.GeographyTypes?.Region.Label, appState)?.Value || 'Region', value: "Region" },
        District: { label: getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.GeographyTypes?.District.Label, appState)?.Value || 'District', value: "District" },
        Territory: { label: getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.GeographyTypes?.Territory.Label, appState)?.Value || 'Territory', value: "Territory" }
    }
    const [geographyTypes, setGeographyTypes] = useState([]);

    const isSelectedGeography = function (territory) {
        switch (selectedGeographyType) {
            case constants.Area.value:
                return territory.salesAreaId === selectedGeography?.value;
            case constants.Region.value:
                return territory.salesRegionId === selectedGeography?.value;
            case constants.District.value:
                return territory.salesDistrictId === selectedGeography?.value;
            case constants.Territory.value:
                return territory.id === selectedGeography?.value;
            default:
                return false;
        }
    };

    const checkSelectedGeographyForProduct = (markets) => {
        if (selectedGeography?.value == null || filterState?.selectedProductIds == null || filterState?.selectedProductIds.length === 0) {
            return true;
        }
        for (const market of markets) {
            for (const territory of market.territories) {
                const hasCommon = territory.productId.some((id) => filterState.selectedProductIds.includes(id));
                if (isSelectedGeography(territory) && hasCommon) {
                    return true;
                }
            }
        }
        return false;
    };

    useEffect(() => {
        let geographyLabel = defaultLabel;
        if (isEnabled) {
            const markets = JSON.parse(sessionStorage.getItem('marketsForUser'));
            if (selectedGeography?.value != null) {
                //if the selected geography is not valid for the selected products, clear it
                if (!checkSelectedGeographyForProduct(markets)) {
                    setSelectedGeography(null);
                    setSelectedGeographyType(null);
                    setFilterState((prevState) => ({
                        ...prevState,
                        selectedGeographyType: null,
                        selectedGeography: null,
                        selectedGeographyLabel: null
                    }));
                } else {
                    geographyLabel = selectedGeography?.length > 12 ? selectedGeography.slice(0, 12) + '...' : selectedGeography?.label;
                }
            }
            buildUniqueLists(markets);
            buildGeographyTypeList();
        }

        setSelectedLabel(geographyLabel);
    }, [isEnabled, filterState.selectedProductIds]);

    function buildGeographyTypeList() {
        if (geographyTypesAreaEnabled?.Value === "true") {
            setGeographyTypes(prev => [...prev.filter(a => a.value !== constants.Area.value), constants.Area]);
        }
        if (geographyTypesRegionEnabled?.Value === "true") {
            setGeographyTypes(prev => [...prev.filter(a => a.value !== constants.Region.value), constants.Region]);
        }
        if (geographyTypesDistrictEnabled?.Value === "true") {
            setGeographyTypes(prev => [...prev.filter(a => a.value !== constants.District.value), constants.District]);
        }
        if (geographyTypesTerritoryEnabled?.Value === "true") {
            setGeographyTypes(prev => [...prev.filter(a => a.value !== constants.Territory.value), constants.Territory]);
        }
    }

    function buildUniqueLists(markets) {
        const salesAreas = new Map();
        const salesRegions = new Map();
        const salesDistricts = new Map();
        const territories = new Map();

        markets.forEach((market) => {

            market.territories.forEach((territory) => {
                const hasCommon = territory.productId.some(id => filterState.selectedProductIds.includes(id));
                if (!hasCommon) {
                    return;
                }
                if (!salesAreas.has(territory.salesAreaId)) {
                    if (territory.salesAreaId != null) {
                        salesAreas.set(territory.salesAreaId, {
                            label: territory.salesArea,
                            value: territory.salesAreaId
                        });
                    }
                }

                if (!salesRegions.has(territory.salesRegionId)) {
                    if (territory.salesRegionId != null) {
                        salesRegions.set(territory.salesRegionId, {
                            label: territory.salesRegion,
                            value: territory.salesRegionId
                        });
                    }
                }

                if (!salesDistricts.has(territory.salesDistrictId)) {
                    if (territory.salesDistrictId != null) {
                        salesDistricts.set(territory.salesDistrictId, {
                            label: territory.salesDistrict,
                            value: territory.salesDistrictId
                        });
                    }
                }

                if (!territories.has(territory.id)) {
                    if (territory.id != null) {
                        territories.set(territory.id, {
                            label: territory.name,
                            value: territory.id
                        });
                    }
                }

            })
        });

        setSalesAreas(Array.from(salesAreas.values()));
        setSalesRegions(Array.from(salesRegions.values()));
        setSalesDistricts(Array.from(salesDistricts.values()));
        setTerritories(Array.from(territories.values()));
    }



    useEffect(() => {
        if (isEnabled) {
            switch (selectedGeographyType) {
                case constants.Area.value:
                    setFilteredOptions(salesAreas);
                    break;
                case constants.Region.value:
                    setFilteredOptions(salesRegions);
                    break;
                case constants.District.value:
                    setFilteredOptions(salesDistricts);
                    break;
                case constants.Territory.value:
                    setFilteredOptions(territories);
                    break;
                default:
                    setFilteredOptions([]);
            }
        }

    }, [selectedGeographyType, territories, salesAreas, salesRegions, salesDistricts, isEnabled]);

    function handleApplyButtonClick(event) {
        let geographyLabel = defaultLabel;
        if (selectedGeography?.value != null) {
            geographyLabel = selectedGeography?.length > 12 ? selectedGeography.slice(0, 12) + '...' : selectedGeography?.label;
        }

        setFilterState(prevState => ({
            ...prevState,
            selectedGeographyType: selectedGeographyType,
            selectedGeography: selectedGeography?.value,
            selectedGeographyLabel: geographyLabel
        }));
        setSelectedLabel(geographyLabel);
        setPreviousSelections({ selectedGeographyType: selectedGeographyType, selectedGeography: selectedGeography?.value, selectedGeographyLabel: geographyLabel });
        setIsMenuVisible(false);
        setfilterAction(FilterDropDown.SetAction(FilterDropDown.ActionTypes.Apply, { selectedGeographyType: selectedGeographyType, selectedGeography: selectedGeography?.value, selectedGeographyLabel: geographyLabel }));
    }

    function handleResetButtonClick(event) {
        resetFilter();
    }

    function handleCancelButtonClick(event) {
        if (previousSelections?.selectedGeographyType !== null) {
            setSelectedGeographyType(previousSelections.selectedGeographyType);
            setSelectedGeography(previousSelections.selectedGeography)
        }
        setIsMenuVisible(false);

        setfilterAction(FilterDropDown.SetAction(FilterDropDown.ActionTypes.Clear, previousSelections));
    }

    function resetFilter() {
        setfilterAction(FilterDropDown.SetAction(FilterDropDown.ActionTypes.Reset, null));
        setSelectedGeographyType(null);
        setSelectedGeography(null);
        setFilteredOptions([]);
    }

    return (
        <div className="mb-4 my-lg-0">
            <button
                disabled={!isEnabled}
                ref={menuRef}
                onClick={() => setIsMenuVisible(isMenuVisible => !isMenuVisible)}
                aria-expanded={isMenuVisible ? "true" : "false"}
                className="border-0 px-0 bg-transparent text-start d-block"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside">
                <div
                    className={!isEnabled ? "p-3 opacity-50" : "p-3"}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <span className="type-20 type-bold me-2">{selectedLabel}</span>
                        </div>
                        <span className="fa-solid fa-chevron-down"></span>
                    </div>
                </div>
            </button>
            <div
                ref={menuContentRef}
                className="dropdown-rc-options"
                id="dropdown-rc-options">
                <div className={`dropdown-menu dropdown-menu-end ${isMenuVisible ? "show" : " "}`}>

                    <div className='p-3'>
                        <FilterDropDown
                            Key="SelectGeographyTypeFilter"
                            isSearchable={false}
                            options={geographyTypes}
                            label={getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.SelectGeographyType?.Label, appState)?.Value}
                            onChange={(selectedOption) => { setSelectedGeographyType(selectedOption.value); }}
                            isEnabled={geographyTypes !== undefined && geographyTypes.length > 0}
                            action={filterAction}>
                        </FilterDropDown>
                    </div>

                    <div className='p-3'>
                        <FilterDropDown
                            key="SelectGeographyFilter"
                            isSearchable={true}
                            options={filteredOptions}
                            label={getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.SelectGeography?.Label, appState)?.Value}
                            onChange={(selectedOption) => { setSelectedGeography(selectedOption) }}
                            isEnabled={filteredOptions !== undefined && filteredOptions?.length > 0}
                            action={filterAction}>
                        </FilterDropDown>
                    </div>

                    <hr></hr>
                    <div className='d-flex justify-content-center p-3'>
                        <Button size="lg" className='btn btn-link text-decoration-underline ms-auto px-4 py-2 no-hover' variant="secondary" onClick={(e) => handleResetButtonClick(e)}>
                            {getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Geography?.Reset, appState)?.Value || null}
                        </Button>
                        <Button size="lg" className='btn btn-secondary  px-4 py-2  ms-md-3' variant="secondary" onClick={(e) => handleCancelButtonClick(e)}>
                            {getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Geography?.Cancel, appState)?.Value || null}
                        </Button>
                        <Button size="lg" className='px-4 py-2  ms-md-3' variant='primary' onClick={(e) => handleApplyButtonClick(e)}>
                            {getConfigValue(appState?.config?.UtilizationDashboard?.Filters?.Geography?.Apply, appState)?.Value || null}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReportGeographyDropDown;